import { IRouteAll, RouteActionTypes, ADD_ROUTE, UPDATE_ROUTE, DELETE_ROUTE } from "./types";
import _ from 'lodash';

const initialState: IRouteAll[] = [

]

export function RouteChange(
    state = initialState,
    action: RouteActionTypes
): IRouteAll[] {

    switch (action.type) {
        case ADD_ROUTE:
            return _.uniqBy([...state, action.data], 'link');
        case UPDATE_ROUTE:
            if (action.data.name && action.data.link) {
                const findex = _.findIndex(state, ['link', action.data.link])
                state[findex].name = action.data.name;
            }
            return [...state];
        case DELETE_ROUTE:

            return [];
        default:
            return state;
    }

}